import React, { useState } from "react";

export const MultiSelectDropdown = ({ label, options, selected, setSelected }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOption = (value) => {
    setSelected((prev) =>
      prev.includes(value)
        ? prev.filter((v) => v !== value)
        : [...prev, value]
    );
  };

  return (
    <div className="relative inline-block min-w-[160px]">
      <button
        className="border px-3 py-2 rounded w-full text-left bg-white"
        onClick={() => setIsOpen((prev) => !prev)}
        type="button"
      >
        {selected.length > 0
          ? `${selected.length} selected`
          : `Select ${label}`}
      </button>

      {isOpen && (
        <div className="absolute z-10 mt-2 bg-white border rounded shadow max-h-60 overflow-y-auto w-full">
          {options.map((opt) => (
            <label
              key={opt.id}
              className="flex items-center px-3 py-1 hover:bg-gray-100 cursor-pointer"
            >
              <input
                type="checkbox"
                checked={selected.includes(opt.id)}
                onChange={() => toggleOption(opt.id)}
                className="mr-2"
              />
              {opt.name}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};
